import { useLayoutEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth } from 'hooks/UseAuth'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { CREATE_WORKSPACE_PATH } from 'paths'
import { findPrivateWorkspaces } from 'utils/workspaceUtils'
import { useLocation } from 'react-router-dom'
import { currentPath } from 'utils/urlUtils'
import { isUndefined } from 'lodash'

const useEnforceWorkspaceCreation = () => {
  const auth = useAuth()
  const history = useHistory()
  const workspaces = useWorkspaces()
  const location = useLocation()

  const currentUrl = currentPath(location)

  useLayoutEffect(() => {
    const performRedirect = async () => {
      // if the user is logged in
      if (!!auth) {
        const hasWorkspace = !!findPrivateWorkspaces(workspaces).length

        // Make sure the user creates a workspace if she didn't complete the sign up.
        if (!isUndefined(auth.signed_up) && !auth.signed_up && !hasWorkspace) history.push(CREATE_WORKSPACE_PATH)
      }
    }
    performRedirect()
  }, [auth, workspaces, history, currentUrl])
}

export { useEnforceWorkspaceCreation }
